import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);


var config =  {
    chart: {
        type: 'bar'

    },
    legend: {
        enabled: false
    },

    title: {
        text: ''
    },

    tooltip: {
        useHTML: true,
        headerFormat: '<table>',
        pointFormat: '<tr><th colspan="0"><h3>{point.x}h</h3></th></tr>' +
            '<tr><th>Uso:</th><td>{point.y}%</td></tr>',
        footerFormat: '</table>',
        followPointer: true
    },

    xAxis: {},

    yAxis: {},

    series: []

}

export default function RaspaCycleDistributionOnHourColumnChart(prop) {
    const { series, filter } = prop;

    let datasets = [];
    let configs = [];


    if (series) {

        let auxd = 0;
        let auxh = 0;
        let auxarray = [];
        let categories = [];
        let cyclesarray = [];


        //debugger;
        series.map(i => {
            let d = new Date(i.Data).toISOString();

            if (d !== auxd) {

                auxd = d;

                if (auxarray.length > 0) {
                    while (auxarray.length <= 23) {
                        auxarray.push(0);
                    }
                    cyclesarray.push({label: auxd.slice(0,10), data: auxarray});
                }

                auxh = 0;

                categories.push(d);
                auxarray = [];
            }

            while (auxh  <  i.Hora) {
                auxarray.push(0);
                auxh += 1;
            }

            auxarray.push(Math.round(i.PercTempo * 100));
            auxh +=1;

        })

        if (auxarray.length > 0) {
            while (auxarray.length <= 23) {
                auxarray.push(0);
            }
        }
        cyclesarray.push({label: auxd.slice(0,10), data: auxarray});

        cyclesarray.map( (s,i) => {
            datasets.push({
                name: s.label,
                data: s.data
            })
        })


        datasets.map( (dataset, i) => {
            configs.push( {
                ...config,
                chart: {
                    type: 'bar',
                    marginLeft: i === 0 ? 60 : 10,
                    width: i === 0 ? 120 : 70
                },


                xAxis: {
                    categories: [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
                    title: {
                        text: 'Hora do dia'
                    },
                    labels: {
                        format: '{value}h',
                        enabled: i === 0
                    }
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    title: {
                        text: dataset.name
                    },
                    labels: {
                        enabled: false
                    }
                },
                series: [dataset]
            })
        })
    }

    return (
        <Card title="laos">
            <h3>Uso nas horas do dia</h3>
            <table>
                <tr>
                    <td>
                        <table id="container">

                            <tr>
                        {configs.map( c => {
                            return (<td><ReactHighcharts config = {c}>
                            </ReactHighcharts></td>)
                        } )}
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>

        </Card>
    )
}
